import { render, staticRenderFns } from "./SidebarLayout.vue?vue&type=template&id=1cc00ef4&"
import script from "./SidebarLayout.vue?vue&type=script&lang=js&"
export * from "./SidebarLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports